import {type BackendAPIBlueprint, type BackendAPITypes} from "../../../../../generated/blueprint.ts";
import {QueryKey} from "../../../../../api/queryKeys.ts";
import {useKeysetInfiniteQuery} from "../../../../../hooks/useKeysetInfiniteQuery.ts";
import type {PartnerTransactionsParams} from "./partnerTransactionsParams.ts";

export const PARTNER_TRANSACTIONS_PAGE_SIZE = 100;

export type PartnerTransactionsPage = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsGetResponseBody;
export type PartnerTransactionItem = PartnerTransactionsPage['items'][number];

export function usePartnerTransactionsInfinite(api: BackendAPIBlueprint, params: PartnerTransactionsParams) {
    return useKeysetInfiniteQuery<PartnerTransactionsPage, PartnerTransactionsParams>({
        api,
        queryKey: QueryKey.PartnerTransactions,
        path: 'partner/transactions',
        params,
        pageSize: PARTNER_TRANSACTIONS_PAGE_SIZE,
    });
}
